<template>
    <div>

        <!-- Sales Analysis Start -->
        <div class="row">
            <div class="col-md-6">
                <h1 class="section--title">Sales Analysis
                    <span>
                        <toggle-button 
                            v-model="selected.avgdaily"
                            :width="100"
                            :height="25"
                            color="#7dCE94" 
                            :sync="true" 
                            :labels="{checked: 'Avg Daily', unchecked: 'Total Daily'}"
                        />
                    </span>
                </h1>

                <div class="periodButton btn-group btn-group-toggle mt-3" data-totggle="buttons">
                    <label class="btn btn-secondary" v-for="period in options.periodFilter" :class="{'active' : selected.salesAnalysisMain.period == period}">
                        <input type="radio" name="options" :value="period" autocomplete="off" v-model="selected.salesAnalysisMain.period"> {{ period }}
                    </label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 col-md-3 ">                        
                        <Multiselect 
                            :options="options.salesAnalysis.dealer.map(x => x.code)"
                            :custom-label="opt => options.salesAnalysis.dealer.find(x => x.code == opt).name"
                            placeholder="All Dealer"
                            v-model="selected.salesAnalysisMain.dealer" 
                        />
                    </div>
                    <div class="col-6 col-md-3 ">                        
                        <Multiselect 
                            :options="options.salesAnalysis.segment.map(x => x.segment)"
                            placeholder="All Segment"
                            v-model="selected.salesAnalysisMain.segment" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.salesAnalysis.type.map(x => x.type)"
                            placeholder="All Type"
                            v-model="selected.salesAnalysisMain.type" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            v-if="options.dateFilter"
                            :options="options.dateFilter.map(x => x.value)"
                            :custom-label="opt => options.dateFilter.find(x => x.value == opt).label"
                            :show-labels="false"
                            :allow-empty="false"
                            placeholder="Choose Period"
                            v-model="selected.salesAnalysisMain.date" 
                        />
                    </div>
                </div>
            </div>
        </div>

        <sales-analysis-bar-line-chart
            v-if="selected.salesAnalysisMain.period == 'Bulanan'"
            :data="data.salesAnalysisMonthly"
        ></sales-analysis-bar-line-chart>
        <sales-analysis-weekly-chart
            v-if="selected.salesAnalysisMain.period == 'Mingguan'"
            :data="data.salesAnalysisWeekly"
        ></sales-analysis-weekly-chart>
        <!-- Sales Analysis End -->

        <div class="dh--divider"></div>

        <!-- Detail Sales Analysis Start -->
        <div class="row">
            <div class="col-md-6">
                <h1 class="section--title">Detail Sales Analysis</h1>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 col-md ">                        
                        <Multiselect 
                            :options="options.salesAnalysisDetails.dealer.map(x => x.code)"
                            :custom-label="opt => options.salesAnalysisDetails.dealer.find(x => x.code == opt).name"
                            placeholder="All Dealer"
                            v-model="filter.salesAnalysisDetails.dealer" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.salesAnalysisDetails.segment.map(x => x.segment)"
                            placeholder="All Segment"
                            v-model="filter.salesAnalysisDetails.segment" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.salesAnalysisDetails.type.map(x => x.type)"
                            placeholder="All Type"
                            v-model="filter.salesAnalysisDetails.type" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            v-if="options.dateFilter"
                            :options="options.dateFilter.map(x => x.value)"
                            :custom-label="opt => options.dateFilter.find(x => x.value == opt).label"
                            :show-labels="false"
                            :allow-empty="false"
                            placeholder="Choose Period"
                            v-model="selected.salesAnalysisDetails.date" 
                        />
                    </div>
                    <div class="col-6 col-md">
                        <button
                            class="btn btn-dh-download"
                            @click="downloadDetailPrep"
                        >Download CSV&nbsp;&nbsp;<i class="fas fa-download"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <detail-sales-analysis-table
            :data="data.salesAnalysisDetails"
        ></detail-sales-analysis-table>
        <!-- Detail Sales Analysis End -->

    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import moment from 'moment'
    import { ToggleButton } from 'vue-js-toggle-button'

    import salesAnalysisBarLineChart from './charts/salesAnalysisBarLineChart'
    import salesAnalysisWeeklyChart from './charts/salesAnalysisWeeklyChart'
    import detailSalesAnalysisTable from './children/detailSalesAnalysisTable'

    export default {
        data () {
            //Frist day of the year
            let startDate = moment().startOf('year');

            //If now passes june already, add 6 month start from first day of year
            if (parseInt(moment().format("M")) > 6) startDate.add(6, 'month');

            //Sixth month from startDate
            let sixthMonth = moment(startDate).add(5, 'month').endOf('month');

            let chosenDate = `${startDate.format("YYYY-MM-DD")} - ${sixthMonth.format("YYYY-MM-DD")}`;

            return {

                options : {
                    dateFilter : null,
                    salesAnalysis : {
                        segment : this.$store.getters.getSimpleSegment(),
                        type : this.$store.getters.getSimpleType(),
                        dealer : this.$store.getters.getDealer()
                    },
                    salesAnalysisDetails : {
                        segment : this.$store.getters.getSimpleSegment(),
                        type : this.$store.getters.getSimpleType(),
                        dealer : this.$store.getters.getDealer()
                    },
                    periodFilter : ['Bulanan', 'Mingguan']
                },
                
                selected : {
                    salesAnalysisMain : {
                        date : chosenDate,
                        period : 'Bulanan',
                        segment : '',
                        type : '',
                    },
                    salesAnalysisDetails : {
                        date : chosenDate
                    },
                    avgdaily : false
                }

            }
        },
        props : ['filter', 'data'],
        components : {
            Multiselect,
		    ToggleButton,

            salesAnalysisBarLineChart,
            salesAnalysisWeeklyChart,
            detailSalesAnalysisTable,
        },
        mounted () {
            this.generateDateOptions();
        },
        watch : {
            'selected.salesAnalysisMain.segment' () {
                this.options.salesAnalysis.type = this.$store.getters.getSimpleType(null, this.selected.salesAnalysisMain.segment, null);
                this.selected.salesAnalysisMain.type = null;
            },
            'selected.salesAnalysisMain' : {
                deep : true,
                handler () {
                    let dates = this.selected.salesAnalysisMain.date.split(" - ");

                    let filter = {
                        segment : this.selected.salesAnalysisMain.segment,
                        type : this.selected.salesAnalysisMain.type,
                        start : dates[0],
                        end : dates[1],
                        dealer : this.selected.salesAnalysisMain.dealer
                    }

                    this.filter.salesAnalysisMonthly = this.filter.salesAnalysisWeekly = filter;
                }
            },
            'filter.salesAnalysisDetails.segment' () {
                this.options.salesAnalysisDetails.type = this.$store.getters.getSimpleType(null, this.filter.salesAnalysisDetails.segment, null);
                this.filter.salesAnalysisDetails.type = null;
            },
            'selected.salesAnalysisDetails.date' () {
                let dates = this.selected.salesAnalysisDetails.date.split(" - ");
                this.filter.salesAnalysisDetails.start = dates[0];
                this.filter.salesAnalysisDetails.end = dates[1];
            },
            'selected.avgdaily' () {
                for (var i in this.filter) this.filter[i].avgdaily = this.selected.avgdaily ? 1 : 0;
            },
        },
        methods : {
            generateDateOptions () {
                let targetYear = 2018;
                let currentYear = moment().format('YYYY');

                let options = [];
                for (var i = currentYear; i >= targetYear; i--) {
                    //2 Semesters in 1 year
                    for (var j = 2; j >=1; j--) {
                        let start = moment().set({year:i, month:(j-1)*6, date:1}).format("YYYY-MM-DD");
                        let end = moment(start).add(5, 'month').endOf('month').format('YYYY-MM-DD');
                        options.push({
                            label : `S${j} - ${i}`,
                            value : `${start} - ${end}`
                        })
                    }
                }

                //If june of this year has not been met yet
                if (parseInt(moment().format("M")) <= 6) options.splice(0, 1);

                this.options.dateFilter = options;
            },
            downloadDetailPrep(){
                let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                let data = this.data.salesAnalysisDetails.map((x)=>{return{
                    "Bulan" : monthNames[x.month-1],
                    "No. Of Sales" : this.numberWithCommas(x.sales)
                }})
                this.exportCsv(data, `Data detail sales analysis`);
            },
        }
    }
</script>

<style scoped>
    .periodButton .btn-secondary {
        background: #FFDBC5;
        border: 0;
        padding: 7px 60px;
        color: #F36F21;
        cursor: pointer;
        font: normal normal 500 18px/21px Ubuntu;
    }

    .periodButton .btn-secondary.active {
        background: #F36F21;
        color: white;
    }
</style>